<template>
  <div class="login-view">
    <div class="background"/>
    <div class="modal-wrapper">
      <div
        :class="{'animated wobble':hasError}"
        class="form-modal animated">
        <login-form @onError="onError"/>
      </div>
    </div>
    <div class="copyright">
      ©AGCO de México S. de R.L. Todos los derechos reservados
    </div>
  </div>
</template>

<script>
import LoginForm from '@/modules/login/login-form'

export default {
  name: 'LoginView',
  components: { LoginForm },
  data () {
    return {
      hasError: false
    }
  },
  methods: {
    onError () {
      this.hasError = true
      setTimeout(() => {
        this.hasError = false
      }, 1500)
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
  .login-view {
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #E02119;
    .modal-wrapper {
      z-index: 100;
    }
  }

  .logo {
    width: 100px;
    margin: 0 auto;
    img {
      max-width: 100%;
    }
  }

  .form-modal {
    width: 400px;
    header {
      .logo {
        padding: 20px;
        text-align: center;
        img {
          width: 130px;
        }
      }
    }
  }

  .forgot-password-link {
    color: #fff;
    width: 400px;
    @include font-primary(12px, bold);
    text-align: center;
    display: block;
    padding: 10px;
  }

  .copyright {
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 400px;
    margin-left: -200px;
    text-align: center;
    color: #fff;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    padding: 15px 20px;
    @include font-primary(12px, bold, normal);
  }
</style>



// WEBPACK FOOTER //
// src/views/login/login-view.vue